const services = [
  // AI Model Training
  { name: 'Custom AI Model Fine-Tuning', category: 'AI Model Training', tier: 'tier-standard', tierLabel: 'Standard', price: '₹2,500 – ₹5,000', delivery: '7–21 days', includes: 'GPT/LLaMA fine-tuning, evaluation report, model deployment' },
  { name: 'Dataset Preparation & Cleaning', category: 'AI Model Training', tier: 'tier-basic', tierLabel: 'Basic', price: '₹3,500 – ₹8,000', delivery: '3–7 days', includes: 'Labeling, deduplication, formatting, quality checks' },
  { name: 'RAG System Setup', category: 'AI Model Training', tier: 'tier-premium', tierLabel: 'Premium', price: '₹40,000 – ₹1,20,000', delivery: '7–14 days', includes: 'LangChain, vector DB, document Q&A, embeddings' },
  // AI Integration
  { name: 'OpenAI / Claude API Integration', category: 'AI Integration', tier: 'tier-standard', tierLabel: 'Standard', price: '₹25,000 – ₹80,000', delivery: '5–12 days', includes: 'API setup, custom prompts, content generators, summarizers' },
  { name: 'AI Chatbot for Website', category: 'AI Integration', tier: 'tier-premium', tierLabel: 'Premium', price: '₹30,000 – ₹90,000', delivery: '7–14 days', includes: 'Custom bot logic, FAQ automation, lead capture, CRM integration' },
  { name: 'AI Automation (Zapier/Make)', category: 'AI Integration', tier: 'tier-standard', tierLabel: 'Standard', price: '₹15,000 – ₹50,000', delivery: '3–8 days', includes: 'Workflow automation, trigger setup, multi-step pipelines' },
  // AI Content
  { name: 'AI Content Removal / Humanizing', category: 'AI Content', tier: 'tier-basic', tierLabel: 'Basic', price: '₹600 – ₹2,500 / 1000 words', delivery: '1–3 days', includes: 'Bypass AI detectors, natural tone, GPTZero/Originality.AI safe' },
  { name: 'Prompt Engineering', category: 'AI Content', tier: 'tier-basic', tierLabel: 'Basic', price: '₹10,000 – ₹35,000', delivery: '2–5 days', includes: 'System prompts, chain-of-thought, few-shot examples, documentation' },
  // Data & NLP
  { name: 'Sentiment Analysis Pipeline', category: 'Data & NLP', tier: 'tier-premium', tierLabel: 'Premium', price: '₹25,000 – ₹80,000', delivery: '5–10 days', includes: 'Social media analysis, review processing, dashboard, alerts' },
];

const CATEGORY_COLORS = {
  'AI Model Training': '#1800ad',
  'AI Integration': '#5b3fff',
  'AI Content': '#1800ad',
  'Data & NLP': '#5b3fff',
};

export default function AIServices() {
  let lastCat = null;
  return (
    <div className="d-card">
      <div className="d-ctitle">AI & ML Solutions — Service Packages</div>
      <table className="d-table">
        <thead>
          <tr>
            <th>Package / Service</th>
            <th>Category</th>
            <th>Type</th>
            <th>Price Range</th>
            <th>Delivery</th>
            <th>Includes</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {services.map((s, i) => {
            const showCat = s.category !== lastCat;
            lastCat = s.category;
            return (
              <>
                {showCat && (
                  <tr key={s.category + '-header'}>
                    <td colSpan={7} style={{ background: '#eef0ff', fontWeight: 700, fontSize: 12, color: CATEGORY_COLORS[s.category], padding: '8px 12px', borderBottom: '1px solid #c5caff' }}>
                      🤖 {s.category}
                    </td>
                  </tr>
                )}
                <tr key={s.name}>
                  <td><b style={{ color: '#1a1a1a' }}>{s.name}</b></td>
                  <td style={{ fontSize: 11, color: '#666' }}>{s.category}</td>
                  <td><span className={`pricing-tier ${s.tier}`}>{s.tierLabel}</span></td>
                  <td style={{ color: '#1800ad', fontWeight: 600 }}>{s.price}</td>
                  <td>{s.delivery}</td>
                  <td style={{ fontSize: 11, color: '#444' }}>{s.includes}</td>
                  <td><span className="d-st s-active">Active</span></td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
      <div style={{ marginTop: 14, background: '#eef0ff', padding: 12, borderRadius: 8, fontSize: 13, color: '#3d3555', border: '1px solid #c5caff' }}>
        💡 <b>LathiNyx DevLabs</b> pricing is flexible. Custom quotes available for complex AI projects. Contact via <a href="https://lathinyxdevlabs.com" target="_blank" rel="noreferrer" style={{ color: '#1800ad' }}>lathinyxdevlabs.com</a>
      </div>
    </div>
  );
}
